import { css } from "styled-components";
import { spaceMixin } from "../spaceMixin";
import { StyledRatingStars } from "../../components/RatingStars/RatingStars";
import { StyledTextButton } from "../../components/TextButton/TextButton";
import { TextButtonMixin } from "./TextButtonMixin";
/** @class LabeledRatingStars */

/** @method */

export var LabeledRatingStarsMixin = function LabeledRatingStarsMixin(props) {
  return css(["display:inline-flex;align-items:center;", "{margin-right:", ";}", "{", "}"], StyledRatingStars, spaceMixin("xs")(props), StyledTextButton, TextButtonMixin(Object.assign({}, props, {
    buttonType: "secondary",
    fontType: "bodySmall"
  })));
};